function getErrorMessage({ elem, isEmail, isPassword, isRequired = false, minlength = 0, maxlength = Infinity }) {
        // Required field validation
        if (isRequired && !elem.value) {
        return "שדה חובה";
    }
    // Email validation
    if (isEmail) {
        return isValidEmail(elem.value) ? '' : "כתובת מייל לא תקינה";
    }

    // Password validation
    if (isPassword) {
        if (elem.value.length < minlength) {
            return `נא להזין מינימום ${minlength} תווים`;
        }
        if (elem.value.length > maxlength) {
            return `נא להזין מקסימום ${maxlength} תווים`;
        }
        return '';
    }



    // Default case (no validation needed)
    return '';
}


// Helper function to validate email format
function isValidEmail(value) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
}
